(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.card'

  angular
    .module(MODULE_NAME, [
      require('./card')
    ])

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/card/index.js